module.exports = __webpack_public_path__ + "assets/images/dropdown-green-star-icon.6c71ce7d9a33ae4c83c28f3123ca9abd.svg";